import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { LabelService } from '../../services/label.service';

import { FormsModule } from '@angular/forms';
import {
  LabelAndDescription,
  PatientAnamnesis,
  PatientFamilyMember,
} from '../../models/patient-model';
import { SharedModule } from '../../shared/shared.module';
import { PatientService } from '../../services/patient.service';
import { Subject, takeUntil } from 'rxjs';
import { ErrorPanelService } from '../../services/error-panel.service';
import { response } from 'express';
import { ConfirmationPanelComponent } from '../../shared/confirmation-panel/confirmation-panel.component';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-anamnesis',
  standalone: true,
  imports: [FormsModule, SharedModule, MatIconModule],
  templateUrl: './anamnesis.component.html',
  styleUrl: './anamnesis.component.scss',
})
export class AnamnesisComponent implements OnChanges {
  @Input() patientId: string = '';
  @Input() anamnesisPersonalFields: string[] = [];
  @Input() anamnesis!: PatientAnamnesis;
  @Input() fieldIsReadOnly: boolean = true;
  @Input() familyMembers: PatientFamilyMember[] = [];
  @Input() anamnesisClinicHistoryFields: string[] = [];

  oldAnamnesis: PatientAnamnesis | null = null;

  showAddRelativePanel: boolean = false;
  showDeleteRelativePanel: boolean = false;
  inputBoxesForNewFamilyMember: LabelAndDescription[] = [
    { label: 'relation', description: '' },
    { label: 'name', description: '' },
    { label: 'age', description: '' },
    { label: 'occupation', description: '' },
    { label: 'other', description: '' },
  ];
  selectedFamilyMember: PatientFamilyMember = {
    id: '',
    patient_id: '',
    relationship: '',
    name: '',
    age: 0,
    occupation: '',
    other: '',
  };

  constructor(
    public labelService: LabelService,
    private patientService: PatientService,
    public errorPanelService: ErrorPanelService,
    private changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['anamnesis'] && !this.oldAnamnesis) {
      this.oldAnamnesis = JSON.parse(JSON.stringify(this.anamnesis));
    }
    if (changes['fieldIsReadOnly']) {
      let isAnamnesisChanged = false;
      if (this.fieldIsReadOnly === true) {
        for (let key in this.anamnesis) {
          if (
            this.oldAnamnesis &&
            this.anamnesis[key] !== this.oldAnamnesis[key]
          ) {
            // almeno un campo è cambiato
            isAnamnesisChanged = true;
            break;
          }
        }
        if (isAnamnesisChanged) {
          this.updateAnamnesis();
        }
      }
    }
  }

  toggleNewRelativePanel() {
    this.showAddRelativePanel = !this.showAddRelativePanel;
  }

  addNewRelative(event: LabelAndDescription[]) {
    var obj = {
      patient_id: this.patientId,
      relationship:
        event.find((e) => e.label === 'relation')?.description || '',
      name: event.find((e) => e.label === 'name')?.description || '',
      age: event.find((e) => e.label === 'age')?.description || '',
      occupation:
        event.find((e) => e.label === 'occupation')?.description || '',
      other: event.find((e) => e.label === 'other')?.description || '',
    };
    this.patientService.createFamilyMember(obj).subscribe({
      next: (response) => {
        (console.log('Nuovo familiare aggiunto'),
          this.familyMembers.push(response));
        this.toggleNewRelativePanel();
      },
      error: (error) => {
        console.error('Qualcosa è andato storto', error);
        this.toggleNewRelativePanel();
        this.errorPanelService.showErrorSnackBar(
          "Errore nell'aggiungere un nuovo familiare"
        );
      },
    });
  }

  deleteFamilyMember(familyMember: PatientFamilyMember) {
    const dialogRef = this.dialog.open(ConfirmationPanelComponent, {
      data: {
        title: 'Sei sicuro di voler eliminare questo familiare?',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.patientService.deleteFamilyMember(familyMember.id).subscribe({
          next: (response) => {
            console.log('Familare eliminato con successo');
            this.familyMembers = this.familyMembers.filter(
              (member) => member.id !== familyMember.id
            );
          },
          error: (err) => {
            console.error('Errore nella cancellazione del familiare', err);
            this.errorPanelService.showErrorSnackBar(
              'Errore nella cancellazione di un familiare'
            );
          },
        });
      }
    });
  }

  updateAnamnesis() {
    const filteredAnamnesis: { [key: string]: any } = {};
    for (let key in this.anamnesis) {
      // Controlla che il valore non sia nullo e che la chiave non sia 'id'
      if (this.anamnesis[key] !== null && key !== 'id') {
        filteredAnamnesis[key] = this.anamnesis[key];
      }
    }
    this.patientService
      .putAnamnesis(this.anamnesis.id, filteredAnamnesis)
      .subscribe({
        next: (response) => {
          console.log('Anagrafica Aggiornata');
        },
        error: (err) => {
          console.error("Errore nell'aggiornare l'anagrafica", err);
          this.errorPanelService.showErrorSnackBar(
            "Errore nell'aggiornare l'anagrafica"
          );
        },
      });
    this.familyMembers.forEach((member) => {
      this.patientService.putFamilyMember(member.id, member).subscribe({
        next: (response) => {
          console.log('Familare aggiornato con successo');
        },
        error: (err) => {
          console.error('Errore nella modifica del familiare', err);
          this.errorPanelService.showErrorSnackBar(
            'Errore nella modifica del familiare ' + member.name
          );
        },
      });
    });
  }
}
